import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { installKoErrorMap } from '@forbiz/contracts'

// 디자인 토큰 → 폰트 → 기본 요소 스타일 순서. 순서가 중요하다(토큰을 뒤가 참조).
import '@forbiz/ui/tokens.css'
import '@forbiz/ui/fonts.css'
import '@forbiz/ui/base.css'
// D1 재사용 프리미티브(btn·field·ptab·democard·rband·stpill …). 전역 클래스지만
// 앱 화면은 CSS 모듈(해시)만 써서 이름이 겹치지 않는다 — 명시적으로 얹은 데만 적용된다.
// 홈 4블록 개편(BIZ-99)·주문흐름(D2)이 이 클래스를 쓴다.
import '@forbiz/ui/components.css'

import { App } from './App.js'

// zod 기본(영어) 검증 메시지를 한국어로. 폼들이 issue.message를 그대로 노출하므로 전역에서 한 번(BIZ-28).
installKoErrorMap()

const root = document.getElementById('root')
if (!root) throw new Error('#root가 없다')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
